import { NgClass } from '@angular/common';
import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [TranslatePipe, MatTooltip, NgClass, MatButtonModule, MatIcon],
  selector: 'iot-platform-ui-subscription-button',
  templateUrl: './subscription-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./subscription-button.component.scss']
})
export class SubscriptionButtonComponent {
  isCurrentUserSubscribed = input<boolean>(false);

  // eslint-disable-next-line @angular-eslint/no-output-native
  click = output<void>();
}
